var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 8.06543H34.7184V29.9346H35.7852V8.06543Z",
    fill: "#24292A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78163 8.06543H2.71484V29.9346H3.78163V8.06543Z",
    fill: "#24292A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 29.9345L35.7852 28.8411L2.71475 28.8411L2.71475 29.9345L35.7852 29.9345Z",
    fill: "#24292A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 9.15889L35.7852 8.06543L2.71475 8.06543L2.71475 9.15889L35.7852 9.15889Z",
    fill: "#24292A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 13.5327L35.7852 12.4392L2.71475 12.4392L2.71475 13.5327L35.7852 13.5327Z",
    fill: "#24292A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11549 13.5327H8.04871L8.04871 29.9346H9.11549L9.11549 13.5327Z",
    fill: "#24292A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4495 13.5327H13.3827L13.3827 29.9346H14.4495L14.4495 13.5327Z",
    fill: "#24292A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7835 13.5327H18.7167L18.7167 29.9346H19.7835L19.7835 13.5327Z",
    fill: "#24292A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1173 13.5327H24.0505L24.0505 29.9346H25.1173L25.1173 13.5327Z",
    fill: "#24292A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4513 13.5327H29.3845L29.3845 29.9346H30.4513L30.4513 13.5327Z",
    fill: "#24292A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 19L35.7852 17.9065L3.78154 17.9065L3.78154 19L35.7852 19Z",
    fill: "#24292A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7852 24.4672L35.7852 23.3738L3.78154 23.3738L3.78154 24.4672L35.7852 24.4672Z",
    fill: "#24292A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.62dead33a986bc0a4ccbaeb779ef4f47.svg";
export { ForwardRef as ReactComponent };